export default {
  methods: {
    toast(message, type = "success", opts) {
      this.$toasted.show(message, {
        position: "top-right",
        type,
        duration: 3000,
        ...opts
      });
    },

    errorToast(message) {
      this.$toasted.global.error({ message });
    },

    successToast(message) {
      this.$toasted.global.success({ message });
    },

    warningToast(message) {
      this.$toasted.global.warning({ message });
    },

    //Show only errors in toasts which have 422 status
    //and have no "field" in meta for displaying under field's area
    showServerErrors(e) {
      if (e.status === 422 || e.status === 409) {
        e.errors.forEach(error => {
          if (error.code_name !== "UNPROCESSABLE_ENTITY") {
            this.toast(error.message, "error");
          }
        });
      }
    }
  }
};
